/**
 * Copyright (c) 2010-2021 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { LocalStorageProxy } from '../../modules/shared/local-storage-shim';
import { Injectable, Injector } from '@angular/core';

@Injectable()
export class OpenIdStorageShim extends LocalStorageProxy {
    constructor() {
        super();
        this.prefix += '_oidc';
        this.rememberBasedKeys.push('access_token', 'id_token', 'refresh_token');
    }
}
